// extracted by mini-css-extract-plugin
export default {"tag":"lcCe6","web":"MFL2U","live":"Yf4Rp","onNow":"p4Y4l","earlyAccess":"xt5Ho","language":"dk5D_","top10":"loIFS","fullHD":"b2NwP"};